export interface ScrollOffsetParams {
  navMenuHeight: number;
  featuredLabelEnabled: boolean;
  productIndex: number;
}

export const PRODUCT_FEATURED_LABEL_HEIGHT = 25;
export const BASE_EXTRA_OFFSET = 20;
export const EXTRA_OFFSET_FOR_NOT_FIRST_ELEMENT = 40;

export const calculateProductScrollOffset = ({
  navMenuHeight,
  featuredLabelEnabled,
  productIndex,
}: ScrollOffsetParams): number => {
  const productOffset =
    navMenuHeight +
    BASE_EXTRA_OFFSET +
    (featuredLabelEnabled ? PRODUCT_FEATURED_LABEL_HEIGHT : 0);

  if (productIndex === 0) {
    return -productOffset;
  }

  return -(productOffset + EXTRA_OFFSET_FOR_NOT_FIRST_ELEMENT);
};
